<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="收款单名称">
          <el-input placeholder="请输入收款单名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="供应商名称">
          <el-input placeholder="请输入供应商名称" v-model="formInline.pfd">
        
          </el-input>
        </el-form-item>
        <el-form-item label="付款状态">
          <el-select size="small" v-model="formInline.pay_status" placeholder="请选择">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="未付款" :value="10"></el-option>
            <el-option label="已付款" :value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="付款方式">
          <el-select size="small" v-model="formInline.pay_on" placeholder="请选择">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="线上付款" :value="10"></el-option>
            <el-option label="线下付款" :value="20"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      

            <el-table-column prop="order_no" label="单号"></el-table-column>
            <el-table-column prop="supply.name" label="供应商"></el-table-column>
            <el-table-column prop="user.nickName" label="下单用户"></el-table-column>
            <el-table-column prop="extract_store.store_name" label="下单门店"></el-table-column>
            <el-table-column prop="order_id" label="关联订单号">
              <template slot-scope="scope">
                <a @click="toDetail(scope.row.order_id)"
                style="color:blue;"
                >订单详情</a>
              </template>

            </el-table-column>
            <el-table-column prop="total_price" label="应收金额"></el-table-column>
            <el-table-column prop="pay_price" label="实收金额"></el-table-column>
            <el-table-column prop="pay_type.text" label="支付方式"></el-table-column>
            <el-table-column prop="transaction_id" label="支付流水号"></el-table-column>
            <el-table-column prop="reconciliation_text" label="对账状态"></el-table-column>
            <el-table-column prop="reconciliation_time" label="对账时间"></el-table-column>
            <el-table-column prop="pay_status.text" label="付款状态"></el-table-column>
            <el-table-column prop="pay_on_text" label="付款方式"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="update_time" label="修改时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">操作</el-button>
     
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :order_id="order_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Payment_receiptApi from '@/api/payment_receipt.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          pfd:"",
          pay_status:0,
          pay_on:0,
        },

        open_add:false,
        open_edit:false,
        order_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
       /*查看详情*/
      toDetail(order_id) {
        let self = this;
        this.$router.push({
          path: '/order/order/Detail',
          query: {
            order_id: order_id
          }
        });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//收款单标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Payment_receiptApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.order_id = row.order_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Payment_receiptApi.del(
              {
                order_id: row.order_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/payment_receipt/index/index.vue